import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import styles from './VideoItem.module.css'
import { Affix, Button, Card, Divider, Flex, message, Space, Tag } from 'antd'
import classNames from 'classnames'
import { getVideoPlayerAuthRequest } from './MSGZSListApi'
import Aliplayer from 'aliyun-aliplayer'
import 'aliyun-aliplayer/build/skins/default/aliplayer-min.css'
import {
  EditOutlined,
  EllipsisOutlined,
  SettingOutlined,
} from '@ant-design/icons'
import videoPlayerIcon from './videoPlayerIcon.svg'

var player
export default function VideoItem(props) {
  //   const count = useSelector(selectCount);
  const dispatch = useDispatch()
  const [messageApi, contextHolder] = message.useMessage()

  // const incrementValue = Number(incrementAmount) || 0;
  useEffect(() => {
    // 在这里执行你的组件挂载后的逻辑
    // 这里可以返回一个清理函数，它会在组件卸载前执行
    console.log('---------->>aslkdfj')
    return () => {
      // console.log('组件即将卸载');
    }
  }, []) // 空数组意味着这个 effect 只会在组件挂载时执行一次
  return (
    <Card
      style={{
        width: '30%',
        marginBottom: '20px',
        marginRight: '1.5%',
        marginLeft: '1.5%',
        paddingBottom: 40,
      }}
      onClick={(e) => {
        props.playVideo(props.info)
      }}
      cover={
        <div
          style={{
            position: 'relative',
            width: '100%',
            aspectRatio: '333/197',
            overflow: 'hidden',
          }}
        >
          <img
            alt="coverImg"
            src={props.info.video_imageurl}
            style={{ cursor: 'pointer', width: '100%', height: '100%',objectFit:'cover'  }}
          />
          <div
            style={{
              position: 'absolute',
              left: '40%',
              top: '30%',
              width: '20%',
              aspectRatio: '1/1',
            }}
          >
            <img
              alt="playIcon"
              src={videoPlayerIcon}
              style={{
                cursor: 'pointer',
                width: '100%',
                height: '100%',
                objectFit:'cover'
              }}
            />
          </div>
        </div>
      }
      hoverable={true}
    >
      <Card.Meta
        title={props.info.video_title}
        // description={props.info.video_des}
        description={<div className={styles.description}>{props.info.video_des}</div>}
      />
      <Flex
        justify="space-between"
        style={{ position: 'absolute', bottom: 20, width: 'calc(100% - 50px)' }}
      >
        <text style={{ color: '#9da4b1' }}>时长:{props.info.video_time}</text>
        <text style={{ color: '#9da4b1' }}>
          播放:{props.info.video_play_num}
        </text>
      </Flex>
    </Card>
  )
}
